const FEATURES = {
  UPLOAD_FREE_CHIPS:
    process.env.VUE_APP_FEATURE_UPLOAD_FREE_CHIPS &&
    process.env.VUE_APP_FEATURE_UPLOAD_FREE_CHIPS.toLowerCase() === 'true'
}

export const isFeatureEnabled = featureName => {
  return FEATURES[featureName] || false
}
